// extracted by mini-css-extract-plugin
module.exports = {"checkboxInputRow":"r_sj","checkboxInputColumn":"r_sk","inputOptionRow":"r_r7","inputOptionColumn":"r_r8"};